// Automatic first attribute: the attribute with the highest entropy (guidance of the 2021 paper, Section 6).
// Separate from attribute-heuristics.js, which needs the metric code: this module is part of the worker bundle.
import { baseOrder } from '../enumeration/config-id.js';
import { isClose } from '../metrics/tolerance.js';

// Shannon entropy (bits) of the category distribution of one attribute.
export function entropy(dataset, name) {
    const counts = new Map();
    for (const row of dataset.rows) counts.set(row[name], (counts.get(row[name]) || 0) + 1);
    const n = dataset.rows.length;
    let h = 0;
    for (const c of counts.values()) h -= (c / n) * Math.log2(c / n);
    return h;
}

/**
 * Attribute with the highest entropy; ties (1e-9) go to fewer categories (fewer colors), then to the base order.
 * normalized: entropy divided by log2 |C| (evenness of the categories; the 2021 text asks for "equal-sized
 * categories"), which does not favor attributes with many categories. Attributes with one category score 0.
 */
export function entropyFirstAttribute(dataset, { normalized = false } = {}) {
    let best = null;
    for (const a of baseOrder(dataset)) {
        const n = a.categories.length;
        const h = n < 2 ? 0 : entropy(dataset, a.name) / (normalized ? Math.log2(n) : 1);
        if (best === null || (h > best.h && !isClose(h, best.h)) || (isClose(h, best.h) && n < best.n)) best = { name: a.name, h, n };
    }
    return best.name;
}
